(function () {
  const SELECTORS = {
    image: ".main-blog__image-slider",
    text: ".main-blog__text-slider",
    counter: ".main-blog__counter",
    current: ".main-blog__current-slide",
    total: ".main-blog__total-slides",
    next: ".main-blog__nav-button--next",
    prev: ".main-blog__nav-button--prev",
  };
  function updateCounters(index) {
    document.querySelectorAll(SELECTORS.counter).forEach((counter) => {
      const current = counter.querySelector(SELECTORS.current);
      if (current) current.textContent = index + 1;
    });
  }
  function initTotalCounter(swiper) {
    const total = swiper.el.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    ).length;
    document.querySelectorAll(SELECTORS.counter).forEach((counter) => {
      const totalEl = counter.querySelector(SELECTORS.total);
      if (totalEl) totalEl.textContent = total;
    });
  }
  function initSliders(scope = document) {
    const textEl = scope.querySelector(SELECTORS.text);
    const imageEl = scope.querySelector(SELECTORS.image);
    if (!textEl || textEl.swiper) return;
    const autoplayEnabled = textEl.dataset.autoplay === "true";
    const autoplayDelay = Number(textEl.dataset.swiperAutoplay) || 5000;
    const common = {
      slidesPerView: 1,
      speed: 800,
      loop: true,
      allowTouchMove: true,
    };
    const imageSwiper = imageEl
      ? new Swiper(imageEl, {
          ...common,
          effect: "slide",
        })
      : null;
    const textSwiper = new Swiper(textEl, {
      ...common,
      effect: "fade",
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: document.querySelector(SELECTORS.next),
        prevEl: document.querySelector(SELECTORS.prev),
      },
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      on: {
        init(swiper) {
          initTotalCounter(swiper);
          updateCounters(swiper.realIndex);
        },
        slideChange(swiper) {
          updateCounters(swiper.realIndex);
        },
      },
    });
    if (imageSwiper) {
      textSwiper.controller.control = imageSwiper;
      imageSwiper.controller.control = textSwiper;
    }
  }
  function init() {
    if (typeof Swiper !== "undefined") initSliders();
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
  if (typeof Shopify !== "undefined") {
    document.addEventListener("shopify:section:load", (e) => {
      initSliders(e.target);
    });
  }
})();
